import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import { IconProps } from "./types";

export function CheckListIcon({ size, ...props }: IconProps) {
    return <ChecklistRoundedIcon fontSize={size} {...props} />;
}
